import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoriesSection from "./components/CategoriesSection";
import AboutSection from "./components/AboutSection";
import FeaturedProducts from "./components/FeaturedProducts";
import MarketsSection from "./components/MarketsSection";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedProducts />
        <AboutSection />
        <MarketsSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
